const formatter = new Intl.DateTimeFormat('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
})

// Renders ISO 8601 timestamps from the backend in the browser's timezone as dd.mm.yyyy hh:mm:ss.
export function formatDateTime (value) {
    if (!value) {
        return ''
    }

    const date = new Date(value)

    if (Number.isNaN(date.getTime())) {
        return value
    }

    const parts = Object.fromEntries(formatter.formatToParts(date).map(part => [part.type, part.value]))

    return `${parts.day}.${parts.month}.${parts.year} ${parts.hour}:${parts.minute}:${parts.second}`
}

export default {
    install: (app) => {
        app.config.globalProperties.$formatDateTime = formatDateTime
    }
}
